<div class="container-fluid">
    <div class="row g-2 justify-content-end">
        <div class="col-md-10 d-flex justify-content-end">
            <div class="col-md-4 me-2">
                <div class="input-group">
                    <input class="form-control" name="frmDate" [(ngModel)]="fromDate" autocomplete="off" ngbDatepicker
                        (ngModelChange)="onFromDate($event)" #d1="ngbDatepicker" placeholder="From Date">
                    <span class="input-group-text pointer" (click)="d1.toggle()">
                        <i class="bi bi-calendar"></i>
                    </span>
                </div>
            </div>
            <div class="col-md-4">
                <div class="input-group">
                    <input class="form-control" name="toDate" [(ngModel)]="toDate" autocomplete="off" ngbDatepicker
                        #d2="ngbDatepicker" [minDate]="minStart" placeholder="To Date">
                    <span class="input-group-text pointer" (click)="d2.toggle()">
                        <i class="bi bi-calendar"></i>
                    </span>
                </div>
            </div>
            <div class="col-md-3 mt-1">
                <button class="btn btn-success btn-sm ms-2 me-2" (click)="onSubmit()">Submit</button>
                <button class="btn btn-danger btn-sm" (click)="onClear()">Clear</button>
            </div>
        </div>
    </div>
    @if (errorMessage) {
        <div class="row mt-2">
            <div class="col-md-10 offset-md-2">
                <div class="text-danger small">{{ errorMessage }}</div>
            </div>
        </div>
    }
</div>